import { Timestamp } from "firebase/firestore";

/**
 * Cloud Function → Firestore
 * Converte dados de um envio de automação para o formato do log no Firestore.
 */
export const automationLogToFirestore = (data, tenantData) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    const payload = {
        idTenant,

        // Referência ao gatilho
        trigger: data.trigger,
        triggerLabel: data.triggerLabel,
        category: data.category,

        // Canal
        channel: data.channel,

        // Destinatário
        recipientType: data.recipientType,
        recipientId: data.recipientId,
        recipientName: data.recipientName,
        recipientPhone: data.recipientPhone,
        recipientEmail: data.recipientEmail,

        // Conteúdo
        messagePreview: (data.messageFull || "").substring(0, 200),
        messageFull: data.messageFull,

        // Status
        status: data.status,
        errorCode: data.errorCode,
        errorMessage: data.errorMessage,

        // Provedor externo
        externalMessageId: data.externalMessageId,
        providerResponse: data.providerResponse,

        // Origem
        sourceCollection: data.sourceCollection,
        sourceDocId: data.sourceDocId,

        // Timestamps
        sentAt: data.sentAt instanceof Date ? Timestamp.fromDate(data.sentAt) : (data.sentAt || null),
        deliveredAt: data.deliveredAt instanceof Date ? Timestamp.fromDate(data.deliveredAt) : (data.deliveredAt || null),
        readAt: data.readAt instanceof Date ? Timestamp.fromDate(data.readAt) : (data.readAt || null),
        createdAt: data.id ? (data.createdAt || Timestamp.now()) : Timestamp.now(),
    };

    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);
    return payload;
};

/**
 * Firestore → React (UI de logs)
 */
export const automationLogFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    return {
        id: snapshot.id,
        ...data,
        sentAt: data.sentAt?.toDate ? data.sentAt.toDate() : data.sentAt,
        deliveredAt: data.deliveredAt?.toDate ? data.deliveredAt.toDate() : data.deliveredAt,
        readAt: data.readAt?.toDate ? data.readAt.toDate() : data.readAt,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
    };
};
